export const budgetRangeToLowHigh = (r: string) => {
  if (r === 'Lt1M') return { low: 0, high: 1000000 };
  if (r === 'Gt5000M') return { low: 5000000000, high: -1 };

  const m = /In(\d+)Mto(\d+)M/.exec(r);
  if (!m) return { low: 0, high: -1 };
  return {
    low: parseInt(m[1], 10) * 1000000,
    high: parseInt(m[2], 10) * 1000000,
  };
};
